import React, { useState } from "react";
import { Card, CardBody, CardHeader, Collapse } from "reactstrap";
import { Box, ChevronDown, ChevronRight } from "react-feather";
import { ListIgnoredProducts } from "./listIgnoredProducts";

export const IgnoredProducts = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Card className="mb-1">
      <CardHeader
        onClick={toggle}
        className="cursor-pointer d-flex justify-content-between align-items-center"
      >
        <div className="d-flex align-items-center gap-1">
          <div style={{ padding: "10px" }} className="bg-light-warning rounded">
            <Box />
          </div>
          <h3 className="mb-0 ">Produtos Ignorados</h3>
        </div>
        {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody className="p-0">
          <ListIgnoredProducts />
        </CardBody>
      </Collapse>
    </Card>
  );
};
